import { Component } from '@angular/core';

@Component({
  selector: 'admin-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts